import { faAngleDown, faIdBadge, faKey } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { Component } from 'react';
import { level1Modules, level2Modules, level3Modules } from "../modules/Modules";
import Checkbox from '../../../components/UIComponent/Checkbox';
import AuthenticationServices from '../../../services/axiosServices/apiServices/AuthenticationServices';
import SwalServices from '../../../services/swalServices/SwalServices';
import TextInput from '../../../components/UIComponent/TextInput';

export default class RolesAndAccess extends Component {
    constructor(props) {
        super(props);
        this.authServices = new AuthenticationServices();
        this.swalServices = new SwalServices();
        this.state = {
            roleActive: "",
            selectedRole: {},
            // roles: ["Super Admin", "Admin", "HOD", "User"],
            modulesAndAccessList: [],
            roleModules: [],
            roles: [],
            showAddRoleInput: false,
            searchText: "",
            tableHeaders: [
                { label: "Module", width: "40%", align: "left" },
                { label: "View", width: "12%", align: "center" },
                { label: "AddEdit", width: "12%", align: "center" },
                { label: "Delete", width: "12%", align: "center" },
                { label: "Pending Rec", width: "12%", align: "center" },
                { label: "Approved Rec", width: "12%", align: "center" },
            ],
            openTabs: {},
            isOpenModuleID: 2,
            // permissions: {}
            permissions: {
                "StockMaster_CompanyMaster": {
                    view: true,
                    add: false,
                    delete: true,
                    // editable flags
                    viewEditable: true,
                    addEditable: false,
                    deleteEditable: true
                }
            }
        };
    }

    componentDidMount() {
        // const openTabs = {};
        // level1Modules
        //     .filter(m => m !== "Dashboard")
        //     .forEach(moduleName => {
        //         const moduleKey = moduleName.replace(/\s+/g, "");
        //         openTabs[moduleKey] = true;
        //     });
        //this.setState({ openTabs });
        this.getRoles();
    }

    getRoles = () => {
        this.authServices.getRoles().then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                const list = response.responseItem.responseContent;

                if (list?.length > 0) {
                    const grouped = list.reduce((acc, item) => {
                        if (!acc[item.roleCategoryId]) {
                            acc[item.roleCategoryId] = {
                                categoryName: item.roleCategoryName,
                                roles: []
                            };
                        }

                        acc[item.roleCategoryId].roles.push({
                            roleId: item.roleId,
                            roleName: item.roleName
                        });

                        return acc;
                    }, {});

                    const finalList = Object.values(grouped);

                    this.setState({
                        roles: finalList,
                    });
                }
            }
        });
    };

    getModulesWithPermissions = (role) => {
        this.authServices.getModulesWithPermissions(role.roleId).then((response) => {
            if (response.statusCode === 200 && response.responseItem !== null) {
                let modulesAndAccessList = response.responseItem.responseContent;
                this.setState({
                    roleModules: modulesAndAccessList,
                    originalRoleModules: modulesAndAccessList,
                    roleActive: role.roleName,
                    selectedRole: role
                }, () => {
                    // this.loadPermissions(modulesAndAccessList);
                    this.setState(prev => ({
                        openTabs: {
                            ...prev.openTabs,
                            2: true
                        }
                    }))
                });
            }
        });
    }

    savePermissions = () => {
        try {
            const { originalRoleModules, selectedRole } = this.state; // Use original data!

            console.log("Saving permissions for role:", originalRoleModules);

            let permissionList = [];

            originalRoleModules.forEach(main => {
                // ignore modules without submodules
                if (!main.subModuleList || main.subModuleList.length === 0) {
                    return;
                }

                main.subModuleList.forEach(sub => {
                    permissionList.push({
                        SubModuleId: sub.subModuleId,
                        View: sub.viewValue == 1,          // convert to boolean
                        AddEdit: sub.addEditValue == 1,    // convert to boolean
                        Delete: sub.deleteValue == 1,       // convert to boolean
                        PendingRecord: sub.pendingRecordValue == 1,
                        ApprovedRecord: sub.approvedRecordValue == 1,
                    });
                });
            });

            // final object for API
            const saveRequest = {
                roleId: selectedRole.roleId,
                permissions: permissionList
            };

            this.authServices.savePermissions(saveRequest).then(response => {
                if (response.statusCode === 200) {
                    this.swalServices.Success("Permissions saved successfully!");
                    this.getModulesWithPermissions(this.state.selectedRole);
                }
            });

        } catch (ex) {
            this.swalServices.Error("Save Error: " + ex);
        }
    };


    // updateSubPermission = (mainId, subId, field, checked) => {
    //     this.setState(prev => {
    //         const updated = prev.roleModules.map(m => {
    //             if (m.mainModuleId !== mainId) return m;

    //             return {
    //                 ...m,
    //                 subModuleList: m.subModuleList.map(s => {
    //                     if (s.subModuleId !== subId) return s;

    //                     return {
    //                         ...s,
    //                         [field]: checked ? 1 : 0
    //                     };
    //                 })
    //             };
    //         });

    //         return { roleModules: updated };
    //     });
    // };

    updateSubPermission = (mainId, subId, field, checked) => {
        this.setState(prev => ({
            roleModules: prev.roleModules.map(module => {
                if (module.mainModuleId !== mainId) return module;

                return {
                    ...module,
                    subModuleList: module.subModuleList.map(sub => {
                        if (sub.subModuleId !== subId) return sub;

                        return {
                            ...sub,
                            [field]: checked ? 1 : 0
                        };
                    })
                };
            }),

            originalRoleModules: prev.originalRoleModules.map(module => {
                if (module.mainModuleId !== mainId) return module;

                return {
                    ...module,
                    subModuleList: module.subModuleList.map(sub => {
                        if (sub.subModuleId !== subId) return sub;

                        return {
                            ...sub,
                            [field]: checked ? 1 : 0
                        };
                    })
                };
            })
        }));
    };

    // handleSelectAll = (mainId, checked) => {
    //     this.setState(prev => {
    //         const updated = prev.roleModules.map(m => {
    //             if (m.mainModuleId !== mainId) return m;

    //             return {
    //                 ...m,
    //                 subModuleList: m.subModuleList.map(sub => ({
    //                     ...sub,
    //                     viewValue: sub.viewEditable ? (checked ? 1 : 0) : sub.viewValue,
    //                     addEditValue: sub.addEditEditable ? (checked ? 1 : 0) : sub.addEditValue,
    //                     deleteValue: sub.deleteEditable ? (checked ? 1 : 0) : sub.deleteValue
    //                 }))
    //             };
    //         });

    //         return { roleModules: updated };
    //     });
    // };

    handleSelectAll = (mainId, checked) => {
        // Get the list of visible subModuleIds for this mainId
        const visibleSubModuleIds = this.state.roleModules
            .find(module => module.mainModuleId === mainId)
            ?.subModuleList.map(sub => sub.subModuleId) || [];

        this.setState(prev => ({
            roleModules: prev.roleModules.map(module => {
                if (module.mainModuleId !== mainId) return module;

                return {
                    ...module,
                    subModuleList: module.subModuleList.map(sub => ({
                        ...sub,
                        viewValue: sub.viewEditable ? (checked ? 1 : 0) : sub.viewValue,
                        addEditValue: sub.addEditEditable ? (checked ? 1 : 0) : sub.addEditValue,
                        deleteValue: sub.deleteEditable ? (checked ? 1 : 0) : sub.deleteValue
                    }))
                };
            }),
            // Only update the VISIBLE submodules in original data
            originalRoleModules: prev.originalRoleModules.map(module => {
                if (module.mainModuleId !== mainId) return module;

                return {
                    ...module,
                    subModuleList: module.subModuleList.map(sub => {
                        // Only update if this submodule is visible in filtered view
                        if (!visibleSubModuleIds.includes(sub.subModuleId)) return sub;

                        return {
                            ...sub,
                            viewValue: sub.viewEditable ? (checked ? 1 : 0) : sub.viewValue,
                            addEditValue: sub.addEditEditable ? (checked ? 1 : 0) : sub.addEditValue,
                            deleteValue: sub.deleteEditable ? (checked ? 1 : 0) : sub.deleteValue
                        };
                    })
                };
            })
        }));
    };

    // loadPermissions = (modulesAndAccessList) => {
    //     const permissions = {};
    //     const moduleNames = [];

    //     modulesAndAccessList.forEach(m => {
    //         moduleNames.push(m.mainModuleName);

    //         m.subModuleList.forEach(sub => {
    //             const subKey = `${m.mainModuleId}_${sub.subModuleId}`;

    //             permissions[subKey] = {
    //                 view: sub.viewValue === 1,
    //                 add: sub.addEditValue === 1,
    //                 delete: sub.deleteValue === 1,

    //                 viewEditable: sub.viewEditable === 1,
    //                 addEditable: sub.addEditEditable === 1,
    //                 deleteEditable: sub.deleteEditable === 1
    //             };
    //         });
    //     });
    //     debugger;
    //     this.setState({
    //         //apiData,
    //         // permissions,
    //         modulesAndAccessList: moduleNames
    //     });
    // };

    // updatePermission = (subKey, field, value) => {
    //     this.setState(prev => ({
    //         permissions: {
    //             ...prev.permissions,
    //             [subKey]: {
    //                 ...prev.permissions[subKey],
    //                 [field]: value
    //             }
    //         }
    //     }));
    // };

    // getKey = (...parts) => parts.map(p => p.replace(/\s+/g, "")).join("_");

    // updatePermission = (key, field, value) => {
    //     this.setState(prev => ({
    //         permissions: {
    //             ...prev.permissions,
    //             [key]: {
    //                 ...prev.permissions[key],
    //                 [field]: value
    //             }
    //         }
    //     }));
    // };

    handleSearch = (searchText) => {
        this.setState({ searchText }, () => {
            if (this.state.searchText === '') {
                // If search is empty, restore original data
                this.setState({ roleModules: this.state.originalRoleModules });
            } else {
                // Filter from original data, not from current state
                let filteredModules = this.state.originalRoleModules
                    .map(module => ({
                        ...module,
                        subModuleList: module.subModuleList.filter(sub =>
                            sub.subModuleName.toLowerCase().includes(this.state.searchText.toLowerCase())
                        )
                    }))
                    .filter(module => module.subModuleList.length > 0);

                this.setState({ roleModules: filteredModules });
            }
        });
    }

    render() {
        return (
            <div className='role-page'>
                <div className='role-inner grid grid-cols-3 gap-4'>

                    <div className='role-selection bg-white border rounded-[10px] overflow-hidden h-fit'>
                        <div className='bg-[#F9FAFC] border-b px-5 py-3 flex justify-between items-center'>
                            <div className='flex items-center gap-2'>
                                <FontAwesomeIcon icon={faIdBadge} className='text-blue' />
                                <span className='font-semibold'>Roles Management</span>
                            </div>

                            <button
                                onClick={() => this.setState({ showAddRoleInput: !this.state.showAddRoleInput })}
                                className='save-btn btns !bg-white hover:!bg-blue !text-blue hover:!text-white'
                            >
                                Add Role
                            </button>
                        </div>

                        {this.state.showAddRoleInput && (
                            <div className='px-5 py-3 border-b bg-[#F9FAFC]'>
                                <div className='flex items-center border rounded-lg overflow-hidden'>
                                    <input
                                        className='w-full !border-none !outline-none !rounded-none'
                                        placeholder='Enter Role'
                                    />
                                    <button className='bg-blue/10 px-3 py-2 text-blue hover:bg-blue hover:text-white'>
                                        Add
                                    </button>
                                </div>
                            </div>
                        )}

                        <div className='px-5 py-5 grid gap-2'>

                            {this.state.roles.map((category, cIndex) => (
                                <div key={cIndex} className="mb-4">
                                    <div className="px-5 py-1 font-bold text-lg text-gray-700">
                                        {category.categoryName}
                                    </div>

                                    {category.roles.map((role, rIndex) => {
                                        const active = this.state.selectedRole?.roleId === role.roleId;

                                        return (
                                            <div
                                                key={rIndex}
                                                onClick={() => this.getModulesWithPermissions(role)}
                                                className={`px-5 py-1 ml-5 mb-1 rounded border cursor-pointer text-[16px] font-semibold
                                                        ${active
                                                        ? "bg-blue/10 text-blue border-blue"
                                                        : "bg-white text-gray-500 border-gray-300 hover:bg-gray-100"
                                                    }`}
                                            >
                                                {role.roleName}
                                            </div>
                                        );
                                    })}
                                </div>
                            ))}
                        </div>
                    </div>

                    <div className='permission-selection col-span-2 bg-white border overflow-hidden rounded-[10px]'>

                        <div className='bg-[#F9FAFC] p-2.5 border-b flex items-center justify-between gap-3'>
                            <div className='flex items-center gap-2.5'>
                                <FontAwesomeIcon icon={faKey} className='text-blue' />
                                <span className='font-semibold'>
                                    {this.state.roleActive} - Permissions
                                </span>
                            </div>

                            <button className='bg-blue/10 hover:bg-blue hover:text-white px-3 py-2 text-blue font-semibold text-[14px] rounded-[10px] transition-all duration-200 ease'
                                onClick={() => this.savePermissions()}
                            >
                                Save Permissions
                            </button>
                        </div>

                        <div className='flex items-center bg-[#F9FAFC] border-b'>
                            {this.state.tableHeaders.map((head, index) => (
                                <div
                                    key={index}
                                    style={{ width: head.width }}
                                    className={`text-${head.align} px-2.5 py-2.5 text-gray-600 font-semibold`}
                                >
                                    {head.label}
                                </div>
                            ))}
                        </div>
                        <div className='serach px-2.5 py-2.5 bg-[#F9FAFC] border-b'>
                            <TextInput
                                type="text"
                                placeholder="Search Module"
                                className="!w-[40%]"
                                value={this.state.searchText}
                                handleChange={(e) =>
                                    this.handleSearch(e.target.value)
                                }
                            />
                        </div>

                        {this.state.roleModules.map((module, index) => {
                            const isOpen = this.state.searchText
                                ? true
                                : (this.state.openTabs[module.mainModuleId] || false);
                            // const isOpen = this.state.openTabs[module.mainModuleId] ?? true;

                            const subModules = module.subModuleList;

                            const isAllSelected = subModules.every(sub =>
                                sub.viewValue === 1 &&
                                sub.addEditValue === 1 &&
                                sub.deleteValue === 1 &&
                                sub.pendingRecordValue === 1 &&
                                sub.approvedRecordValue === 1
                            );

                            return (
                                <div key={module.mainModuleId}>

                                    {/* MODULE HEADER */}
                                    <div className="bg-[#E9F6FF] px-2.5 py-2.5 flex items-center justify-between">

                                        <div
                                            className="left flex items-center gap-2 cursor-pointer text-blue"
                                            onClick={() =>
                                                this.setState(prev => ({
                                                    openTabs: {
                                                        // ...prev.openTabs,
                                                        [module.mainModuleId]: !isOpen
                                                    }
                                                }))
                                            }
                                        >
                                            <FontAwesomeIcon
                                                icon={faAngleDown}
                                                className={`transition-transform ${isOpen ? "rotate-0" : "-rotate-90"}`}
                                            />
                                            <span className='text-[16px] font-semibold'>{module.mainModuleName}</span>
                                        </div>

                                        {/* SELECT ALL */}
                                        <Checkbox
                                            checked={isAllSelected}
                                            label="Select All"
                                            onChange={e => this.handleSelectAll(module.mainModuleId, e.target.checked)}
                                        />
                                    </div>

                                    {/* SUB MODULE LIST */}
                                    {isOpen && (
                                        <div className="bg-white">
                                            {subModules.map((sub, idx) => (
                                                <div key={sub.subModuleId} className="flex border-b">

                                                    <div className="px-2.5 py-2 w-[40%]">
                                                        {sub.subModuleName}
                                                    </div>

                                                    {/* VIEW */}
                                                    <div className="px-2.5 py-2 w-[12%] text-center">
                                                        {sub.viewEditable === 1 ? (
                                                            <Checkbox
                                                                checked={sub.viewValue === 1}
                                                                onChange={e =>
                                                                    this.updateSubPermission(
                                                                        module.mainModuleId,
                                                                        sub.subModuleId,
                                                                        "viewValue",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        ) : <span>-</span>}
                                                    </div>

                                                    {/* ADD/EDIT */}
                                                    <div className="px-2.5 py-2 w-[12%] text-center">
                                                        {sub.addEditEditable === 1 ? (
                                                            <Checkbox
                                                                checked={sub.addEditValue === 1}
                                                                onChange={e =>
                                                                    this.updateSubPermission(
                                                                        module.mainModuleId,
                                                                        sub.subModuleId,
                                                                        "addEditValue",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        ) : <span>-</span>}
                                                    </div>

                                                    {/* DELETE */}
                                                    <div className="px-2.5 py-2 w-[12%] text-center">
                                                        {sub.deleteEditable === 1 ? (
                                                            <Checkbox
                                                                checked={sub.deleteValue === 1}
                                                                onChange={e =>
                                                                    this.updateSubPermission(
                                                                        module.mainModuleId,
                                                                        sub.subModuleId,
                                                                        "deleteValue",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        ) : <span>-</span>}
                                                    </div>

                                                    {/* PendingRecord */}
                                                    <div className="px-2.5 py-2 w-[12%] text-center">
                                                        {sub.pendingRecordEditable === 1 ? (
                                                            <Checkbox
                                                                checked={sub.pendingRecordValue === 1}
                                                                onChange={e =>
                                                                    this.updateSubPermission(
                                                                        module.mainModuleId,
                                                                        sub.subModuleId,
                                                                        "pendingRecordValue",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        ) : <span>-</span>}
                                                    </div>

                                                    {/* ApprovedRecord */}
                                                    <div className="px-2.5 py-2 w-[12%] text-center">
                                                        {sub.approvedRecordEditable === 1 ? (
                                                            <Checkbox
                                                                checked={sub.approvedRecordValue === 1}
                                                                onChange={e =>
                                                                    this.updateSubPermission(
                                                                        module.mainModuleId,
                                                                        sub.subModuleId,
                                                                        "approvedRecordValue",
                                                                        e.target.checked
                                                                    )
                                                                }
                                                            />
                                                        ) : <span>-</span>}
                                                    </div>

                                                </div>
                                            ))}
                                        </div>
                                    )}
                                </div>
                            );
                        })}

                        {/* {this.state.modulesAndAccessList
                            .filter(m => m !== "Dashboard")
                            .map((moduleName, index) => {

                                const moduleData = this.state.apiData.find(x => x.MainModuleName === moduleName);
                                if (!moduleData) return null;

                                const moduleKey = moduleName.replace(/\s+/g, "");
                                const isOpen = this.state.openTabs[moduleKey] ?? true;

                                const subModules = moduleData.SubModuleList;

                                const isAllSelected = subModules.every(sub => {
                                    const subKey = `${moduleData.MainModuleId}_${sub.SubModuleId}`;
                                    const p = this.state.permissions[subKey];
                                    return p?.view && p?.add && p?.delete;
                                });

                                return (
                                    <div key={index}>

                                       
                                        <div className='bg-[#E9F6FF] px-2.5 py-2.5 flex items-center justify-between cursor-pointer'>
                                            <div
                                                className='left flex items-center gap-2'
                                                onClick={() =>
                                                    this.setState(prev => ({
                                                        openTabs: {
                                                            ...prev.openTabs,
                                                            [moduleKey]: !isOpen
                                                        }
                                                    }))
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={faAngleDown}
                                                    className={`transition-transform text-blue ${isOpen ? "rotate-0" : "-rotate-90"}`}
                                                />
                                                <span className='text-blue font-semibold'>{moduleName}</span>
                                            </div>

                                            <Checkbox
                                                size={18}
                                                color="blue"
                                                checked={isAllSelected}
                                                label="Select All"
                                                onChange={e => {
                                                    const checked = e.target.checked;
                                                    const updated = { ...this.state.permissions };

                                                    subModules.forEach(sub => {
                                                        const subKey = `${moduleData.MainModuleId}_${sub.SubModuleId}`;
                                                        const p = updated[subKey];

                                                        if (p.viewEditable) p.view = checked;
                                                        if (p.addEditable) p.add = checked;
                                                        if (p.deleteEditable) p.delete = checked;
                                                    });

                                                    this.setState({ permissions: updated });
                                                }}
                                            />
                                        </div>

                                        {isOpen && (
                                            <div className='bg-white'>
                                                {subModules.map((sub, idx) => {
                                                    const subKey = `${moduleData.MainModuleId}_${sub.SubModuleId}`;
                                                    const perm = this.state.permissions[subKey];

                                                    return (
                                                        <div key={idx} className='flex items-center border-b'>

                                                            <div className='px-2.5 py-2 flex items-center gap-[5px] w-[40%]'>
                                                                <span className='text-gray-700'>{sub.SubModuleName}</span>
                                                            </div>

                                                            <div className='px-2.5 py-2 w-[15%] text-center'>
                                                                {perm.viewEditable ? (
                                                                    <Checkbox
                                                                        size={18}
                                                                        color="blue"
                                                                        checked={perm.view}
                                                                        onChange={e =>
                                                                            this.updatePermission(subKey, "view", e.target.checked)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <span>-</span>
                                                                )}
                                                            </div>

                                                            <div className='px-2.5 py-2 w-[15%] text-center'>
                                                                {perm.addEditable ? (
                                                                    <Checkbox
                                                                        size={18}
                                                                        color="blue"
                                                                        checked={perm.add}
                                                                        onChange={e =>
                                                                            this.updatePermission(subKey, "add", e.target.checked)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <span>-</span>
                                                                )}
                                                            </div>

                                                            <div className='px-2.5 py-2 w-[15%] text-center'>
                                                                {perm.deleteEditable ? (
                                                                    <Checkbox
                                                                        size={18}
                                                                        color="blue"
                                                                        checked={perm.delete}
                                                                        onChange={e =>
                                                                            this.updatePermission(subKey, "delete", e.target.checked)
                                                                        }
                                                                    />
                                                                ) : (
                                                                    <span>-</span>
                                                                )}
                                                            </div>

                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}

                                    </div>
                                );
                            })} */}

                        {/* {this.state.modulesAndAccessList
                            .filter(m => m !== "Dashboard")
                            .map((moduleName, index) => {

                                const moduleKey = moduleName.replace(/\s+/g, "");
                                const isOpen = this.state.openTabs[moduleKey] ?? true;
                                const subModules = level2Modules[moduleKey] || [];
                                const isAllSelected = subModules.every(sub => {
                                    const subKey = this.getKey(moduleKey, sub);
                                    const p = this.state.permissions[subKey];
                                    return p?.view && p?.add && p?.edit && p?.rate;
                                });
                                return (
                                    <div key={index}>

                                        <div
                                            className='bg-[#E9F6FF] px-2.5 py-2.5 flex items-center justify-between cursor-pointer'
                                        >
                                            <div className='left flex items-center gap-2'
                                                onClick={() =>
                                                    this.setState(prev => ({
                                                        openTabs: {
                                                            ...prev.openTabs,
                                                            [moduleKey]: !isOpen
                                                        }
                                                    }))
                                                }
                                            >
                                                <FontAwesomeIcon
                                                    icon={faAngleDown}
                                                    className={`transition-transform text-blue ${isOpen ? "rotate-0" : "-rotate-90"}`}
                                                />
                                                <span className='text-blue font-semibold'>{moduleName}</span>
                                            </div>

                                            <Checkbox
                                                size={18}
                                                color="blue"
                                                checked={isAllSelected}
                                                label="Select All"
                                                onChange={e => {
                                                    const checked = e.target.checked;
                                                    const updated = { ...this.state.permissions };
                                                    subModules.forEach(sub => {
                                                        const subKey = this.getKey(moduleKey, sub);
                                                        updated[subKey] = {
                                                            view: checked,
                                                            add: checked,
                                                            edit: checked,
                                                            rate: checked
                                                        };
                                                    });

                                                    this.setState({ permissions: updated });
                                                }}
                                            />
                                        </div>

                                        {isOpen && (
                                            <div className='bg-white'>
                                                {subModules.map((subName, idx) => {
                                                    const subKey = this.getKey(moduleKey, subName);

                                                    return (
                                                        <div key={idx} className='flex items-center border-b'>
                                                            <div className='sub-module px-2.5 py-2 flex items-center gap-[5px] w-[40%]'>
                                                                <span className='text-gray-700'>{subName}</span>
                                                            </div>

                                                            {["view", "add", "edit", "rate"].map(field => (
                                                                <div className='px-2.5 py-2 w-[15%] text-center' key={field}>
                                                                    <Checkbox
                                                                        size={18}
                                                                        color="blue"
                                                                        checked={this.state.permissions[subKey]?.[field] || false}
                                                                        onChange={e =>
                                                                            this.updatePermission(subKey, field, e.target.checked)
                                                                        }
                                                                    />
                                                                </div>
                                                            ))}
                                                        </div>
                                                    );
                                                })}
                                            </div>
                                        )}
                                    </div>
                                );
                            })} */}

                    </div>
                </div>
            </div>
        );
    }
}
